module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-7-657be4b90062a289cb8c612cb1f8677a.svg";